/**
 * 多列导航菜单交互逻辑
 */
(function() {
  'use strict';

  function getMegaMenuAlignmentTarget(megaMenu) {
    const header = megaMenu.closest('.header');
    return header ? header.querySelector('.header__primary-link') : null;
  }

  function alignMegaMenuToFirstPrimaryLink(megaMenu) {
    const trigger = getMegaMenuAlignmentTarget(megaMenu);
    const header = megaMenu.closest('.header');

    if (!trigger || !header) return;

    const triggerRect = trigger.getBoundingClientRect();
    const headerRect = header.getBoundingClientRect();
    const offset = Math.max(0, Math.round(triggerRect.left - headerRect.left));

    megaMenu.style.setProperty('--mega-menu-content-inline-start', `${offset}px`);
  }

  function alignAllMegaMenus() {
    document.querySelectorAll('.mega-menu--multi-column').forEach(alignMegaMenuToFirstPrimaryLink);
  }

  function syncMegaMenuColumnWidths(megaMenu) {
    megaMenu.querySelectorAll('.mega-menu__column').forEach(function(column) {
      const heading = column.querySelector('.mega-menu__column-heading');

      if (!heading) {
        column.style.removeProperty('--mega-menu-column-heading-width');
        return;
      }

      const headingWidth = Math.ceil(heading.getBoundingClientRect().width);
      if (headingWidth <= 0) {
        column.style.removeProperty('--mega-menu-column-heading-width');
        return;
      }

      column.style.setProperty('--mega-menu-column-heading-width', `${headingWidth}px`);
    });
  }

  function scheduleMegaMenuColumnWidthSync(megaMenu) {
    syncMegaMenuColumnWidths(megaMenu);
    requestAnimationFrame(function() {
      syncMegaMenuColumnWidths(megaMenu);
    });
  }

  function syncAllMegaMenuColumnWidths() {
    document.querySelectorAll('.mega-menu--multi-column').forEach(syncMegaMenuColumnWidths);
  }

  function refreshAllMegaMenus() {
    alignAllMegaMenus();
    syncAllMegaMenuColumnWidths();
  }

  function initMultiColumnMegaMenu() {
    const megaMenus = document.querySelectorAll('.mega-menu--multi-column');
    
    megaMenus.forEach(function(megaMenu) {
      alignMegaMenuToFirstPrimaryLink(megaMenu);
      syncMegaMenuColumnWidths(megaMenu);

      if (!megaMenu.dataset.megaMenuColumnWidthObserverBound) {
        const observer = new MutationObserver(function() {
          if (megaMenu.hasAttribute('open')) {
            scheduleMegaMenuColumnWidthSync(megaMenu);
          }
        });

        observer.observe(megaMenu, {
          attributes: true,
          attributeFilter: ['open']
        });

        megaMenu.dataset.megaMenuColumnWidthObserverBound = 'true';
      }

      const trigger = getMegaMenuAlignmentTarget(megaMenu);
      if (trigger && !trigger.dataset.megaMenuAlignmentBound) {
        trigger.addEventListener('mouseenter', function() {
          alignMegaMenuToFirstPrimaryLink(megaMenu);
          scheduleMegaMenuColumnWidthSync(megaMenu);
        });
        trigger.addEventListener('focus', function() {
          alignMegaMenuToFirstPrimaryLink(megaMenu);
          scheduleMegaMenuColumnWidthSync(megaMenu);
        });
        trigger.dataset.megaMenuAlignmentBound = 'true';
      }

      const categoryItems = megaMenu.querySelectorAll('.mega-menu__category-item[data-category-index]');
      const subcategoryGroups = megaMenu.querySelectorAll('.mega-menu__subcategory-group');
      
      function switchCategory(index) {
        // 移除所有活动状态
        categoryItems.forEach(function(item) {
          item.classList.remove('mega-menu__category-item--active');
        });
        subcategoryGroups.forEach(function(group) {
          group.classList.remove('mega-menu__subcategory-group--active');
        });
        
        // 添加新的活动状态
        const targetItem = megaMenu.querySelector(`.mega-menu__category-item[data-category-index="${index}"]`);
        const targetGroup = megaMenu.querySelector(`.mega-menu__subcategory-group[data-category-index="${index}"]`);
        
        if (targetItem) {
          targetItem.classList.add('mega-menu__category-item--active');
        }
        if (targetGroup) {
          targetGroup.classList.add('mega-menu__subcategory-group--active');
        }
      }
      
      // 为每个类别项添加事件监听器
      categoryItems.forEach(function(item) {
        const index = item.getAttribute('data-category-index');
        
        // 鼠标悬停事件
        item.addEventListener('mouseenter', function(e) {
          e.preventDefault();
          switchCategory(index);
        });
        
        // 点击事件（移动端）
        item.addEventListener('click', function(e) {
          if (window.innerWidth <= 1000) {
            e.preventDefault();
            switchCategory(index);
          }
        });
      });
    });
  }
  
  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initMultiColumnMegaMenu();
      refreshAllMegaMenus();
    });
  } else {
    initMultiColumnMegaMenu();
    refreshAllMegaMenus();
  }

  window.addEventListener('resize', refreshAllMegaMenus);
  window.addEventListener('load', refreshAllMegaMenus);
  
  // 监听动态内容变化（Shopify主题编辑器）
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      initMultiColumnMegaMenu();
      refreshAllMegaMenus();
    });
  }
})();

/**
 * 去掉主菜单容器的淡入动画，使其立即显示
 */
(function() {
  'use strict';
  
  function removeMainContainerAnimation() {
    // 等待header-mega-menu元素注册完成
    if (!window.customElements.get('header-mega-menu')) {
      setTimeout(removeMainContainerAnimation, 100);
      return;
    }
    
    // 获取HeaderMegaMenu类的原型
    const HeaderMegaMenuProto = window.customElements.get('header-mega-menu').prototype;
    
    // 检查是否已经覆盖过
    if (HeaderMegaMenuProto._animationOverridden) {
      return;
    }
    
    // 保存原始方法
    const originalCreateEnterAnimationControls = HeaderMegaMenuProto.createEnterAnimationControls;
    
    // 覆盖createEnterAnimationControls方法
    HeaderMegaMenuProto.createEnterAnimationControls = function() {
      // 立即设置主容器opacity为1，去掉淡入动画
      this.style.opacity = '1';
      
      const links = this.querySelectorAll(".mega-menu__navigation > *");
      
      // 如果没有子元素动画，返回立即完成的Promise
      if (links.length === 0 || !window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
        return Promise.resolve();
      }
      
      // 只创建子元素的动画（保持原有动画效果）
      try {
        const animations = [];
        
        // 导航链接动画：淡入 + 向上滑动
        links.forEach(function(link, index) {
          const linkAnimation = link.animate(
            { 
              opacity: [0, 1], 
              transform: ["translateY(1em)", "translateY(0)"] 
            },
            { 
              duration: 200, 
              delay: 100 + (index * 50), // 0.1s + stagger (每个元素延迟50ms)
              easing: "ease-in-out",
              fill: "forwards"
            }
          );
          animations.push(linkAnimation);
        });
        
        // 产品图片动画：淡入
        const promoElements = this.querySelectorAll(".menu-promo");
        promoElements.forEach(function(promo) {
          const promoAnimation = promo.animate(
            { opacity: [0, 1] },
            { 
              duration: 300, 
              delay: 100, // 0.1s
              easing: "ease-in-out",
              fill: "forwards"
            }
          );
          animations.push(promoAnimation);
        });
        
        // 返回Promise，在所有子元素动画完成后resolve
        return Promise.all(animations.map(anim => anim.finished));
        
      } catch (e) {
        // 如果出错，回退到原始方法（但主容器opacity已经设置为1）
        console.warn('Failed to create child animations, using original:', e);
        const originalResult = originalCreateEnterAnimationControls.call(this);
        // 确保主容器opacity保持为1
        this.style.opacity = '1';
        return originalResult;
      }
    };
    
    // 标记已覆盖
    HeaderMegaMenuProto._animationOverridden = true;
  }
  
  // 页面加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeMainContainerAnimation);
  } else {
    // 延迟执行，确保theme.js已加载
    setTimeout(removeMainContainerAnimation, 500);
  }
  
  // 监听动态内容变化
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      setTimeout(removeMainContainerAnimation, 100);
    });
  }
})();
